module.exports = __webpack_public_path__ + "img/5H.d64b8d5b.svg";